import { createContext, useContext } from 'react';
import { BenchmarksBootstrapData } from '../guest-journey.hooks';

const BenchmarksContext = createContext<BenchmarksBootstrapData | undefined>(
  undefined,
);

export const BenchmarksProvider = BenchmarksContext.Provider;

/**
 * Access the Benchmarks bootstrap data (brand cuisine + cuisine/year filter
 * options). Must be rendered under a `BenchmarksProvider`, which is set once the
 * bootstrap has resolved all three BE values — so consumers can read them
 * synchronously without null checks.
 */
export const useBenchmarksContext = (): BenchmarksBootstrapData => {
  const context = useContext(BenchmarksContext);
  if (!context) {
    throw new Error(
      'useBenchmarksContext must be used within a BenchmarksProvider',
    );
  }
  return context;
};
